export default __webpack_public_path__ + "static/media/flashlight.03c82fae.svg";